/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/customer/customer_interfaces.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    import IDealerwareCustomerFactory = DealerwareWebServices.IDealerwareCustomerFactory;

    export class AccountSettingsFormDirectiveController {

        public static $inject : string[] = [
            '$dealerwareCustomerFactory',
            '$dealerwareLoading',
            '$scope',
            '$filter',
            '$dealerwareNotification',
            '$mdDialog',
            '$state',
            'CurrentUser',
            'DataUtils',
            'routeShortcuts',
            '$injector'
        ];

        public customer: any;
        public onSaveSuccess: any;
        public onSaveError: any;
        public onCancel: any;
        public accountSettingsForm: any;
        public dataUtils: any;
        private _locationId: number;
        public _showDeleteButton: boolean;

        constructor(public $dealerwareCustomerFactory: any,
                    public $dealerwareLoading: any,
                    public $scope: any,
                    public $filter: any,
                    public $dealerwareNotification: any,
                    public $mdDialog: any,
                    public $state: any,
                    public CurrentUser: any,
                    public DataUtils: any,
                    public routeShortcuts: any,
                    public $injector: any
                    ) {

            if (!this.customer) {
                this.customer = this.$dealerwareCustomerFactory.getInstance();
            }

            this.dataUtils = DataUtils.getInstance();

            const _this = this;
            this.CurrentUser.userModel.getRoles({
                promise: true,
                params: {
                    dealership_id: this.locationId,
                }
            }).then(
                function(returnValue: any, response: any) {
                    if (returnValue.data.map(access => access.name).includes('admin')) {
                        _this.$scope.showDeleteButton = true
                    }
                    else {
                        _this.$scope.showDeleteButton = false
                    }
                },
                function(response: any) {}
            );
        }

        get locationId() : number {
            return this._locationId;
        }

        set locationId(id: number) {
            this._locationId = id;
        }

        public get customerEmail() : string {
            if (this.customer && this.customer.accountSettings) {
                return this.$filter('filterAnonymizedEmail')(this.customer.accountSettings.data.email);
            }
            return undefined;
        }

        public set customerEmail(email: string) {
            this.customer.accountSettings.data.email = email;
        }

        // Force input text into (512) 555-1212 format.
        //
        public formatPhoneNumber ( formatArgs : any ) : any {
            return this.dataUtils.formatPhoneNumber(formatArgs);
        }

        public saveCustomer() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.customer.accountSettings.$update({
                promise: true,
                params: { location_id: this.customer.locationId }
            }).then(
                function() {
                    loader.close();
                    _self.$dealerwareNotification.toast('Account Settings Saved!');
                    _self.customer.accountSettings.markAsMaster();
                    _self.$scope.accountSettingsForm.$setPristine();
                },
                function(response : any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public ccpaDeleteCustomer() : void {
            var _self = this;

            const buttonId = '#ccpa_delete_customer';
            const contracts = this.customer.contracts.data;
            const openContractStates = ['pending_agreement', 'started'];
            const openContracts = contracts.some((contract) => {
                return openContractStates.includes(contract.data.current_state);
            });

            if (openContracts) {
                _self.$mdDialog.show({
                    templateUrl: '/components/customer/account_settings/ccpa_delete_customer_contract_warning_modal.html',
                    openFrom: buttonId,
                    closeTo: buttonId,
                    clickOutsideToClose: true,
                    parent: angular.element(document.body),
                    scope: angular.extend(_self.$scope.$new(), { close: function() {_self.$mdDialog.cancel();} })
                })
            } else {
                _self.$mdDialog.show(this.$mdDialog.confirm({
                    templateUrl: '/components/customer/account_settings/ccpa_delete_customer_balances_warning_modal.html',
                    openFrom: buttonId,
                    closeTo: buttonId,
                    clickOutsideToClose: true,
                    parent: angular.element(document.body),
                    scope: angular.extend(_self.$scope.$new(), { close: function() {_self.$mdDialog.cancel();}, confirm: function() {_self.$mdDialog.hide();}})
                })).then(function() {
                    const loader = _self.$dealerwareLoading.show('Deleting...');

                    var customerId = JSON.stringify([parseInt(_self.customer.customerId)])

                    _self.customer.accountSettings.$ccpaDelete({
                        promise: true,
                        params: {
                            location_id: _self.customer.locationId,
                            customer_ids: customerId
                        }
                    }).then(
                        function() {
                            loader.close();
                            _self.$state.go (
                                _self.routeShortcuts['customersDashboard'].target,
                                {
                                    location_id: _self.customer.locationId,
                                    id: _self.customer.id
                                }
                            )
                        },
                        function(response : any) {
                            loader.close();
                            _self.$dealerwareNotification.apiError(response);
                        }
                    );
                })
            }
        }

        public cancel() : void {
            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        }
    }

    getDealerwareWebComponentsModule().controller('AccountSettingsFormDirectiveController', AccountSettingsFormDirectiveController);


    export class AccountSettingsFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'AccountSettingsFormDirectiveController';
        public controllerAs     : string    =   'accountSettingsController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            onSaveSuccess: '&',
            onSaveError: '&',
            onCancel: '&',
            customer: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/customer/account_settings/account_settings_form_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {
        }

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }


    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCustomerAccountSettingsForm",() => new AccountSettingsFormDirective());

}
